import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/user/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchUser(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/user/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addUser(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/user', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    updateUser(ctx, data)
    {
      return new Promise((resolve, reject) =>{
        axiosIns.put('/user', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    deleteUser(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/user', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStores(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/store/list', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    }
  },
}
